/**
 * @author：
 * @update：
 * @description：
 **/
export default {
    /**
     * treeData 左侧全部列表数据
     * isOpenBol 是否打开弹窗
     * checkDataes 右侧已选内容
     * modelName 弹窗标题
     * resourceName 资源名称
     * leafContent 叶子中资源的内容集合
     * */
    props: {
        'treeData': {},
        'isOpenBol': {},
        'checkDataes': {},
        'modelName': {default: '接口权限'},
        'resourceName': '',
        resourceTitle: {default: '资源名称'},
        'leafContent': {
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            filterText: '',//搜索框输入内容
            delListBol: false,//是否显示多选框
            isIndeterminate: false,//是否半选
            checkAll: false,//是否全选
            checkedKey: [],//右侧勾选内容id

            leftData: [],//左侧内容
            leftDataNum:0,//左侧内容去重后的数量
            rightData: [],//右侧内容
            dataAllList: [],//要删除的内容

            oldId: []
        };
    },
    // 自定义方法
    methods: {
        //模态框关闭
        modelClose() {
            this.$emit('modelClose', '');
            this.dataAllList = [];
            this.delListBol = false;
            this.isIndeterminate = false;

            this.checkedKey = [];
            this.leftData = [];
            this.leftDataNum = 0;
            this.rightData = [];
            this.mapListid = [];
        },
        //树状图过滤搜索函数
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //树状图选中
        handleCheckChange(data, checked) {
            let ids = [...new Set(this.$refs.tree.getCheckedKeys(true))];
            //判断取消还是选中
            if (checked.checkedKeys.includes(data.identity)) {
                let arr = [];
                for (let i = 0; i < ids.length; i++) {
                    for (let j = 0; j < this.leafContent.length; j++) {
                        if (ids[i].split('_')[1] == this.leafContent[j].id) {
                            arr.push(this.leafContent[j].identity)
                        }
                    }
                }
                this.oldId = arr;
                this.$refs.tree.setCheckedKeys(this.oldId, false);
                this.rightData=[];
                for(let i = 0; i < ids.length; i++){
                    for(let j = 0; j < this.leafContent.length; j++){
                        if(ids[i].split('_')[1]==this.leafContent[j].id){
                            this.rightData.push(this.leafContent[j]);
                            this.rightData = this.rightData.reduce((all, next) => all.some((atom) => atom['id'] == next['id']) ? all : [...all, next],[]);//数组中对象去重
                        }
                    }
                }
            } else {
                if (data.type === "ROLE"||data.type==="MENUS") {
                    if(checked.checkedKeys.length!=0){//判断当前子菜单取消后是否还有其他子菜单
                        for (var i = 0; i < checked.checkedKeys.length; i++) {
                            if (checked.checkedKeys[i].split('_')[1] == data.id) {
                                this.$refs.tree.setChecked(checked.checkedKeys[i],false,false);
                            }
                        }
                    }
                    this.rightData.splice(this.rightData.findIndex(item => item.id === data.id), 1);
                }else{
                    let arr = [];//取消的子菜单identity值
                    this.mapList(data.children,arr);
                    let arr2 = [];//通过子菜单identity值对应的id查找全部相同id的identity值
                    for(let i = 0; i < arr.length; i++){
                        for(let j = 0; j < this.leafContent.length; j++){
                            if (arr[i].split('_')[1]==this.leafContent[j].id) {
                                arr2.push(this.leafContent[j].id)
                                this.$refs.tree.setChecked(this.leafContent[j].identity,false,false)
                            }
                        }
                    }
                    arr2 = [...new Set(arr2)];//id去重
                    //右侧数据清除
                    for(let i = 0; i < arr2.length; i++){
                        this.rightData.splice(this.rightData.findIndex(item => item.id === arr2[i]), 1);
                    }
                }
            }
        },
        //递归获取取消的选项下子集
        mapList(data,arr){
            for(let i in data){
                if(data[i].children){
                    this.mapList(data[i].children,arr)
                }else{
                    arr.push(data[i].identity)
                }
            }
        },
        //全选框
        handleCheckAllChange(val) {
            this.dataAllList = val ? this.rightData.map(item => item.id) : [];
            this.isIndeterminate = false;
        },
        //删除时多选框点击事件
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.rightData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.rightData.length;
        },
        //清空按钮
        empty() {
            this.rightData = [];//右侧数据清空
            this.$refs.tree.setCheckedKeys([]);//左侧树状图选中状态清空
        },
        //删除
        delList(id) {
            this.rightData.splice(this.rightData.findIndex(item => item.id === id), 1);
            for (let i = 0; i < this.leafContent.length; i++) {
                if (this.leafContent[i].id == id) {
                    this.$refs.tree.setChecked(this.leafContent[i].identity, false, false);
                }
            }
        },
        //确定移除
        delMoreList() {
            let data = this.dataAllList;
            this.$emit('delMoreList', data);
            this.dataAllList = [];
            this.delListBol = false;
        },
        //接口权限批量移除
        interfaceDelBtn() {
            this.checkAll = false;
            this.delListBol = true;
        },
        //提交
        interfaceBtn() {
            this.$emit('interfaceBtn', this.rightData);
            this.delListBol = false;
        },
    },
    // 数据观察监听
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        treeData(newName, oldName) {
            this.leftData = newName;
        },
        leafContent(newName, oldName){
            let arr = [];
            for(let i = 0; i < newName.length; i++){
                arr.push(newName[i].id)
            }
            arr = [...new Set(arr)]
            this.leftDataNum = arr.length;
        },
        checkDataes(newName, oldName) {
            let arr = [];
            for (let i = 0; i < newName.length; i++) {
                for(let j = 0; j < this.leafContent.length; j++){
                    if(newName[i].id==this.leafContent[j].id){
                        arr.push(this.leafContent[j].identity)
                    }
                }
            }
            this.checkedKey = arr;
            let objs = JSON.stringify(newName);
            this.rightData = JSON.parse(objs);
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
